/**
 * @flow
 * @providesModule Shared
 */

import d3 from "d3";
import Armap from "./armap";
import _ from "../constants";
import camelcase from "camelcase";
import im from "include-media-export/include-media";
import $ from 'jquery';

export type ConfigType = {
    signupSocket: string;
    app: string;
}

export type TransitionInfoType = {
    id: string;
    projectId: string;
    fromId: string;
    toId: string;
}

export type TaskInfoType = {
    id: string;
    projectId: string;
    type: string;
    name: string;
    description: string;
    deadline: number;
    duration: number;
    durationUnit: string;
    state: string;
    groupId: string;
    rowId: string;
    colId: string;
    teamId: string;
    execs: string[];
    timeCreated: number;
    timeUnblocked: number;
    timeStarted: number;
    timeCompleted: number;
    creatorId: string;
    node_p?: SVGElement;
}

export type PointType = {
    x: number;
    y: number;
}

export type RectType = {
    x: number;
    y: number;
    width: number;
    height: number;
}

export function compact (src: Array<any>): Array<any> {
    var r = [];
    (src || []).forEach(function (v) {
        v !== void 0 && r.push(v);
    });
    return r;
}

export function trim(str: string): string {
    return str.replace(/^\s+|\s+$/g, '');
}

export function ctSpan (value: string, x?: string, y?: string, cName?: string): Element {
    let el = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
    x != void 0 && (el: any).setAttributeNS(null, 'x', x);
    y != void 0 && (el: any).setAttributeNS(null, 'dy', y);
    cName && ((el: any).className.baseVal = cName);
    // el.appendChild(document.createTextNode((value || '')/*.unescapeHTML()*/));
    el.textContent = value || '';
    return el;
}

const WORD_SPLITER = /([\x20-\x2f\x3a-\x40])/;

export function fitInto(el: SVGTextElement, value: string, width: number, cut: boolean = false): string {
    if (value.length && (el: any).getComputedTextLength() > width) {
        let words = compact(value.split(WORD_SPLITER));
        let i = 1;
        let al;

        do {
            (el: any).firstChild.nodeValue = words.slice(0, i).join('');
        } while ((al = (el: any).getComputedTextLength()) < width && words.length > i++);

        if (al >= width) {
            if (cut) {
                let v = (el: any).firstChild.nodeValue;
                let avg = al / v.length;
                let rl = Math.floor(width / avg) - 2;

                (el: any).firstChild.nodeValue = v.substr(0, rl) + '…';
            } else {
                if (words.length > i && i < 3) {
                    let v = (el: any).firstChild.nodeValue;
                    let avg = al / v.length;
                    let rl = Math.floor(width / avg) - 1;

                    (el: any).firstChild.nodeValue = v.substr(0, rl).trim();
                    (el: any).insertBefore(ctSpan('⤸', undefined, '1', 'cr'), (el: any).firstChild.nextSibling);
                    words.unshift(v.substr(rl));
                } else if (al - width > 5 || !WORD_SPLITER.test(words[i - 1])) {
                    (el: any).firstChild.nodeValue = words.slice(0, --i).join('').trim();
                    words = words.slice(i);
                } else {
                    words = words.slice(i);
                }
            }
        }

        return words.join('');
    }

    return '';
}

// function wrap(text, width) {
//   text.each(function() {
//     var text = d3.select(this),
//         words = text.text().split(/\s+/).reverse(),
//         word,
//         line = [],
//         lineNumber = 0,
//         lineHeight = 1.1, // ems
//         y = text.attr("y"),
//         dy = parseFloat(text.attr("dy")),
//         tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
//     while (word = words.pop()) {
//       line.push(word);
//       tspan.text(line.join(" "));
//       if (tspan.node().getComputedTextLength() > width) {
//         line.pop();
//         tspan.text(line.join(" "));
//         line = [word];
//         tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
//       }
//     }
//   });
// }

export function processTextNode (el: SVGTextElement, mw: number = _.trTaskWidth - 25): void {
    const $el = d3.select(el);
    const x = $el.attr('x');
    const value = (el: any).textContent;
    let r = '';

    (el: any).textContent = '';

    let v = trim(value).replace(/\n\r|\n|\s{2,}|\t{1,}/g, ' ');
    let firstLine = (el: any).appendChild(ctSpan(v, x + '', '1em'));
    let secondLineValue = fitInto(firstLine, v, mw).trim();

    if (secondLineValue) {
        let secondLine = (el: any).appendChild(ctSpan(secondLineValue, x, '1em'));
        r = fitInto(secondLine, secondLineValue, mw, true);
    }

    $el.attr('title', r ? value : '');
}

export function GBBox(el: SVGElement): RectType {
    let tr = getTranslate(el);
    let {width, height} = (el: any).getBoundingClientRect();

    return {
        x: tr[0],
        y: tr[1],
        width: width,
        height: height
    }
}

export function getTopOffset(elem: HTMLElement): number {
    // let box = getClientRect(elem);//elem.getBoundingClientRect();
    return getClientRect(elem).top + window.pageYOffset;
}

export function getEl(q: string, parent: Document | HTMLElement = document): HTMLElement {
    return parent.querySelector(q);
}

export function getEls(q: string, parent: Document | HTMLElement = document): HTMLElement[] {
    return Array.prototype.slice.call(parent.querySelectorAll(q));
}

export function getStyle(q: string | HTMLElement): CSSStyleDeclaration {
    if (typeof(q) == 'string') {
        return getEl(q).style;
    } else {
        return q.style;
    }
}

export function getClientRect(el: string | HTMLElement | SVGElement): ClientRect {
    if (typeof(el) == 'string') {
        return getEl(el).getBoundingClientRect()
    } else {
        return (el: any).getBoundingClientRect();
    }
}

export function addClass(el: any, name: string | string[]): void {
    if (!el) { return }
    if (typeof(el) == 'string') {
        addClass(getEls(el), name);
    } else if (el instanceof Array) {
        el.forEach(v => {
            addClass(v, name);
        });
    } else {
        if (name instanceof Array) {
            name.forEach((n: string) => {
                el.classList.add(n);
            })
        } else {
            el.classList.add(name);
        }
    }
}

export function removeClass(el: any, name: string): void {
    if (!el) { return }
    if (typeof(el) == 'string') {
        removeClass(getEls(el), name);
    } else if (el instanceof Array) {
        el.forEach(v => {
            removeClass(v, name);
        });
    } else {
        if (/\s/.test(name)) {
            name.split(' ').forEach(n => el.classList.remove(n));
        } else {
            el.classList.remove(name);
        }
    }
}

export function hasClass(el: string | HTMLElement, name: string): boolean {
    if (!el) { return false }
    if (typeof(el) == 'string') {
        return getEl(el).classList.contains(name);
    } else {
        return el.classList.contains(name);
    }
}

export function toggleClass(el: string | HTMLElement, name: string): boolean {
    if (!el) { return false }
    const e: HTMLElement = typeof(el) == 'string' ? getEl(el) : el;

    if (e.classList.toggle) {
        return e.classList.toggle(name);
    } else {
        if (hasClass(e, name)) {
            removeClass(e, name);
            return false;
        } else {
            addClass(e, name);
            return true;
        }
    }
}

function isJSON(data: string):boolean {
    return /^\s*\{/.test(data);
}

export function getHTMLData(el: HTMLElement, id?:string): any {
    if (id) {
        const d = el.dataset[camelcase(id)];
        return isJSON(d) ? JSON.parse(d) : d;
    } else {
        let r = {};
        const d = el.dataset;
        for (let k in d) {
            r[k] = isJSON(d[k]) ? JSON.parse(d[k]) : d[k];
        }
        return r;
    }
}

export function getTranslate (el: SVGElement): Array<number> {
    return d3.transform(d3.select(el).attr('transform')).translate;
}

export function getScale(el: SVGElement): number {
    return d3.transform(d3.select(el).attr('transform')).scale[0];
}

export function isBetween (p: number | Array<number>, s: number, e: number): boolean {
    if (p instanceof Array) {
        let r = true;
        p.forEach(p1 => r = r && p1 > s && p1 < e);
        return r;
    } else {
        return p > s && p < e;
    }
}

export function linkStartXY(d: TransitionInfoType, list: Armap<string, TaskInfoType>, lostLinkXY?:boolean): PointType {
    if (!d) { return {x:0,y:0} }
    let e = list.byId(d.fromId);
    let bb = e && GBBox(e.node_p);

    if (!e) {
        if (lostLinkXY) {
            let exy = linkEndXY(d, list);
            return {
                x: exy.x,
                y: exy.y - 20
            }
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    } else {
        return {
            x: bb.x + _.trTaskWidth / 2,
            y: bb.y + bb.height
        }
    }
}

export function linkEndXY(d: TransitionInfoType, list: Armap<string, TaskInfoType>, lostLinkXY?:boolean): PointType {
    let e = list.byId(d.toId);
    let bb = e && GBBox(e.node_p);

    if (!e) {
        if (lostLinkXY) {
            var sxy = linkStartXY(d, list);
            return {
                x: sxy.x,
                y: sxy.y + 20
            }
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    } else {
        return {
            x: bb.x + _.trTaskWidth / 2,
            y: bb.y - 2
        }
    }
}

//export function scrollBodyTo (pos: number) {
//    $('body').animate({scrollTop: pos}, 250);
//}

export function processSlides (cName: string) {
    $('.' + cName).each(function () {
        const $childs = $(this).find('img');
        const $ul = $('<ul />').addClass('clsSlideShow');
        $childs.each(function () {
            let p = 'url(' + $(this).attr('src').replace(/\s/g, '%20') + ')';
            $ul.append(
                $('<li />')
                    .addClass('clsSlideShowItem')
                    .css('background-image', p)
            );
        });
        $(this).append($ul);
        $childs.remove();
        $ul.find('li').first().addClass('clsImgInTransition');

        if ($childs.length > 1) {
            const $nav = $('<div />').addClass('clsImgNavigator');
            for (let i = 0; i < $childs.length; i++) {
                $('<span />').data('index', i).appendTo($nav);
            }
            $nav.find('span').first().addClass('clsActive');
            // $(this).append($nav);
            //$nav.insertBefore($ul);
            $nav.insertAfter($ul);
        }
    }).on('click', 'ul', function () {
        const $ul = $(this);
        const $lis = $ul.find('li');
        const $active = $ul.find('li.clsImgInTransition');
        let i = $lis.index($active) + 1;
        $active.removeClass('clsImgInTransition');

        if (i == $lis.length) { i = 0 }

        $($lis.get(i)).addClass('clsImgInTransition');

        const $navs = $(this).parent().find('div.clsImgNavigator span');
        $navs.removeClass('clsActive');
        $($navs.get(i)).addClass('clsActive');
    }).on('click', 'div.clsImgNavigator span', function () {
        const $lis = $(this).parents('.' + cName).find('li').removeClass('clsImgInTransition');
        let i = $(this).data('index');
        $($lis.get(i)).addClass('clsImgInTransition');
        $(this).parent().find('span.clsActive').removeClass('clsActive');
        $(this).addClass('clsActive');
    })

}

export function atoi(str: string): number {
    return parseInt(str, 10);
}

export function showImage(src: string, el?: HTMLImageElement) {
    const $shield = $('<div></div>')
        .addClass('clsShield');
    const $el = $(el);
    const {innerWidth: w, innerHeight: h} = window;

    if (el) {
        if (atoi($el.attr('width')) > w || atoi($el.attr('height')) > h) {
            const $img = $('<img />').attr('src', src);
            // $img.on('click', () => {
            //     window.open(src);
            // });
            $shield.append($img);
        } else {
            $shield.css('background-image', `url(${src})`);
        }
    } else {
        $shield.css('background-image', `url(${src})`);
    }

    $('body').append($shield);

    $shield
        .on('click', () => {
            $shield.on(_.gcTransitionEnd, function () {
                $shield.remove();
            }).css('opacity', 0);

            setTimeout(() => {
                $shield.remove();
            }, 250);
        });

    setTimeout(() => {
        $shield.css('opacity', 1);
    }, 50);
}

export function isElementPartiallyInViewport(el: HTMLElement, clientRect?: ClientRect) {
    const { top, left, height, width } = clientRect || el.getBoundingClientRect();

    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    const vertInView = (top <= windowHeight) && ((top + height) >= 0);
    const horInView = (left <= windowWidth) && ((left + width) >= 0);

    return (vertInView && horInView);
}

export function checkBoundries(target: PointType, box: RectType, viewPort: ClientRect, scale: number): PointType {
    let { x: dx, y: dy } = target;
    let { width: bw, height: bh } = box;
    let { width: vpw, height: vph } = viewPort;

    const isMobile = !im.greaterThan('mobile');

    const TOP_BOUNDRY = isMobile ? 10 : 50;
    const BOTTOM_BOUNDRY = isMobile ? 10 : 50;
    const LEFT_BOUNDRY = isMobile ? 10 : 50;
    const RIGHT_BOUNDRY = isMobile ? 10 : 50;
    // debugger;
    // bw += LEFT_BOUNDRY + RIGHT_BOUNDRY;
    // bh += TOP_BOUNDRY + BOTTOM_BOUNDRY;

    if ((bw > vpw && dx > LEFT_BOUNDRY) || (bw < vpw && dx < LEFT_BOUNDRY)) {
        dx = LEFT_BOUNDRY;
    }
    if ((bw > vpw && (dx + bw) - vpw < -RIGHT_BOUNDRY) || (bw < vpw && dx + bw > vpw - RIGHT_BOUNDRY)) {
        dx = vpw - bw - RIGHT_BOUNDRY;
    }
    if ((bh > vph && dy > TOP_BOUNDRY) || (bh < vph && dy < TOP_BOUNDRY)) {
        dy = TOP_BOUNDRY;
    }
    if ((bh > vph && (dy + bh) - vph < -BOTTOM_BOUNDRY) || (bh < vph && dy + bh > vph - BOTTOM_BOUNDRY)) {
        dy = vph - bh - BOTTOM_BOUNDRY;
    }

    return {
        x: dx,
        y: dy
    }
}

export function isElementIsChildOf(el: HTMLElement, parentEl: HTMLElement): boolean {
    let p: HTMLElement = el;
    do {
        p = (p: any).parentElement;
    } while (p != parentEl && p != null);
    return p == parentEl;
}



// WEBPACK FOOTER //
// ./src/lib/stories-shared.js